export default "__VITE_ASSET__8exisMGe__"